import { Box } from 'pcln-design-system'
import { BaggageFeesLink } from '@pcln/fly-ui-components'
import styled from 'styled-components'

const PriceDisclosureContainer = styled(Box)`
  display: inline-block !important;
`
const LowerCaseBaggageFeesLink = styled(BaggageFeesLink)`
  text-transform: lowercase;
  text-decoration: underline;
`
export { PriceDisclosureContainer, LowerCaseBaggageFeesLink }
